export const departments = [
  {
    id: "general-medicine",
    name: "General Medicine",
    icon: "FaStethoscope",
    image: "/facilities/general-medicine.png",
    shortDescription: "Comprehensive primary healthcare, diagnostics, and management of chronic conditions.",
    description: "Our General Medicine department is the cornerstone of SAINIK Hospital. It offers comprehensive primary healthcare services for adult patients. Our skilled internists diagnose and treat a wide range of complex medical issues, focusing on preventive health measures, wellness checks, and chronic disease management.",
    services: [
      "Chronic Disease Management (Diabetes, Hypertension)",
      "Preventive Health Checkups & Vaccinations",
      "Infectious Disease Diagnosis & Treatment",
      "Geriatric (Elderly) Care",
      "Lifestyle Counseling & Wellness Coaching"
    ]
  },
  {
    id: "general-surgery",
    name: "General Surgery",
    icon: "FaHeartbeat",
    image: "/facilities/general-surgery.png",
    shortDescription: "Advanced surgical interventions and minimally invasive procedures.",
    description: "The Department of General Surgery provides state-of-the-art surgical care. Equipped with advanced technology, our surgeons specialize in minimally invasive (laparoscopic) and open surgical procedures. We emphasize patient comfort, rapid recovery, and minimal scarring.",
    services: [
      "Laparoscopic Cholecystectomy (Gallbladder)",
      "Appendectomy & Hernia Repairs",
      "Thyroid and Breast Surgeries",
      "Gastrointestinal & Colorectal Surgeries",
      "Trauma & Emergency Surgical Operations"
    ]
  },
  {
    id: "orthopaedics",
    name: "Orthopaedics",
    icon: "FaBone",
    image: "/facilities/orthopaedics.png",
    shortDescription: "Expert care for bones, joint replacements, sports injuries, and spine rehabilitation.",
    description: "SAINIK Orthopaedics clinic provides exceptional bone, joint, and muscle care. From complex joint replacements and spine surgeries to treating sports injuries and minor fractures, our team is committed to restoring your mobility and keeping you active.",
    services: [
      "Total Knee & Hip Replacement",
      "Arthroscopic Joint Surgeries (Knee, Shoulder)",
      "Fracture & Complex Trauma Management",
      "Spine Decompression & Fusion Care",
      "Sports Medicine & Joint Rehabilitation"
    ]
  },
  {
    id: "obstetrics-gynaecology",
    name: "Obstetrics & Gynaecology",
    icon: "FaBaby",
    image: "/facilities/gynaecology.png",
    shortDescription: "Comprehensive maternal healthcare, luxury delivery suites, and gynaec care.",
    description: "Our OB-GYN department provides compassionate, premium healthcare for women through all stages of life. We offer comprehensive prenatal care, state-of-the-art birthing suites, high-risk pregnancy monitoring, and expert gynaecological diagnostics and surgeries.",
    services: [
      "Painless Delivery & Luxury Birthing Suites",
      "High-Risk Pregnancy Management",
      "Laparoscopic Gynaecologic Surgeries",
      "Infertility Workup & Guidance",
      "PCOS & Menopause Management Programs"
    ]
  },
  {
    id: "paediatrics",
    name: "Pediatrics",
    icon: "FaChild",
    image: "/facilities/paediatrics.png",
    shortDescription: "Compassionate healthcare and immunizations for infants, children, and teens.",
    description: "Our Pediatric team ensures the well-being and growth of children. In a child-friendly environment, we offer round-the-clock pediatric emergency services, pediatric vaccinations, growth monitoring, and treatment for acute/chronic childhood illnesses.",
    services: [
      "Childhood Immunization & Vaccinations",
      "Pediatric Emergency & ICU Support",
      "Growth, Nutrition & Development Tracking",
      "Neonatal Follow-ups",
      "Treatment of Childhood Asthma & Allergies"
    ]
  },
  {
    id: "cardiology",
    name: "Cardiology",
    icon: "FaHeart",
    image: "/facilities/cardiology.png",
    shortDescription: "Advanced cardiac diagnostics, interventional cardiology, and heart wellness.",
    description: "SAINIK Heart Institute stands at the forefront of cardiology. We offer advanced non-invasive and invasive cardiac procedures, including Angiography, Angioplasty, and Pacemaker implantations. Our cardiac rehabilitation program assists in a safe, steady recovery.",
    services: [
      "Interventional Cardiology (Angioplasty/Stenting)",
      "24/7 Primary PCI for Acute Heart Attack",
      "Echocardiogram (ECHO) & Treadmill Test (TMT)",
      "Pacemaker & ICD Implantation",
      "Preventive Cardiac Health Screenings"
    ]
  },
  {
    id: "neurology",
    name: "Neurology",
    icon: "FaBrain",
    image: "/facilities/neurology.png",
    shortDescription: "Neurology evaluations, stroke units, and neuromuscular disorder care.",
    description: "The Neurology department manages brain, spinal cord, nerve, and muscle disorders. We feature a specialized Stroke Unit with thrombolysis capability, alongside diagnostics for epilepsy, Parkinson's disease, dementia, and neuropathies.",
    services: [
      "24/7 Stroke Management & Thrombolysis",
      "Epilepsy & Seizure Disorder Clinic",
      "Parkinson's & Movement Disorders Management",
      "Neuropathy & Headache Management",
      "EEG, EMG, & Nerve Conduction Studies"
    ]
  },
  {
    id: "ent",
    name: "ENT",
    icon: "FaHearingAid",
    image: "/facilities/ent.png",
    shortDescription: "Ear, nose, throat diagnostics, sinus treatments, and microscopic ear surgeries.",
    description: "Our ENT department offers complete diagnosis and treatment of ear, nose, throat, head, and neck conditions. Utilizing microscopic and endoscopic techniques, we perform precise corrective surgeries for hearing loss, sinus problems, and voice issues.",
    services: [
      "Microscopic Ear Surgeries for Hearing Restoration",
      "Functional Endoscopic Sinus Surgery (FESS)",
      "Tonsillectomy & Adenoidectomy",
      "Allergic Rhinitis Management",
      "Snoring & Sleep Apnea Interventions"
    ]
  },
  {
    id: "urology",
    name: "Urology",
    icon: "FaUserShield",
    image: "/facilities/urology.png",
    shortDescription: "Kidney stone laser removal, prostate care, and urinary tract disorders.",
    description: "The Urology department provides diagnostics and treatments for the male and female urinary tract, as well as the male reproductive system. We utilize minimally invasive lasers for stone treatments and advanced surgeries for prostatic issues.",
    services: [
      "Laser Kidney Stone Removal (URSL, RIRS)",
      "Prostate Laser Surgery (HoLEP / TURP)",
      "Urinary Incontinence Management",
      "Uro-Oncology (Cancer Surgeries)",
      "Male Infertility & Sexual Health Support"
    ]
  },
  {
    id: "nephrology",
    name: "Nephrology",
    icon: "FaProcedures",
    image: "/facilities/nephrology.jpg",
    shortDescription: "Advanced dialysis unit, kidney disease management, and transplant workups.",
    description: "Our Nephrology clinic treats kidney disorders with skill and empathy. We run a state-of-the-art Dialysis Unit with round-the-clock support, treating acute kidney injury, chronic kidney disease, and coordinating kidney transplant workups.",
    services: [
      "24/7 Hemodialysis & Peritoneal Dialysis Unit",
      "Chronic Kidney Disease (CKD) Management",
      "Kidney Biopsy and Pathology",
      "Pre- & Post-Kidney Transplant Evaluation",
      "Diabetic Nephropathy Interventions"
    ]
  },
  {
    id: "pulmonology",
    name: "Pulmonology",
    icon: "FaLungs",
    image: "/facilities/pulmonology.png",
    shortDescription: "Asthma, COPD, lung infection management, and sleep study diagnostics.",
    description: "The Pulmonology department handles respiratory diseases, including asthma, COPD, pneumonia, tuberculosis, and pleural disorders. We feature advanced pulmonary function testing (PFT) and sleep diagnostic labs.",
    services: [
      "Asthma and COPD Specialty Clinics",
      "Pulmonary Function Testing (PFT) & Spirometry",
      "Bronchoscopy & Interventional Pulmonology",
      "Sleep Apnea Studies & CPAP Titration",
      "Tuberculosis & Chronic Lung Care"
    ]
  },
  {
    id: "dermatology",
    name: "Dermatology",
    icon: "FaCapsules",
    image: "/facilities/dermatology.png",
    shortDescription: "Skin, hair, nail clinical diagnostics, and cosmetic dermatological procedures.",
    description: "SAINIK Dermatology offers expert treatment for all skin, hair, and nail conditions. From eczema and psoriasis to clinical acne, allergy, and cosmetic dermatology, our doctors restore skin health using advanced technologies.",
    services: [
      "Acne, Psoriasis & Eczema Treatments",
      "Laser Hair Removal & Skin Resurfacing",
      "Dermatopathology & Mole Screenings",
      "Platelet-Rich Plasma (PRP) Therapy for Hair Loss",
      "Chemical Peels & Anti-aging Services"
    ]
  },
  {
    id: "plastic-surgery",
    name: "Plastic Surgery",
    icon: "FaSyringe",
    image: "/facilities/plastic-surgery.png",
    shortDescription: "Reconstructive surgeries, trauma repair, and cosmetic enhancements.",
    description: "Our Plastic and Reconstructive Surgery department reconstructs structures damaged by trauma, cancer, or congenital conditions. We also offer premium aesthetic procedures focused on patient safety and natural-looking outcomes.",
    services: [
      "Reconstructive Surgery for Trauma & Burns",
      "Microvascular Reconstruction Surgery",
      "Cleft Lip & Palate Corrective Surgeries",
      "Cosmetic Procedures (Rhinoplasty, Liposuction)",
      "Scar Revision & Wound Care Management"
    ]
  },
  {
    id: "emergency-medicine",
    name: "Emergency Medicine",
    icon: "FaAmbulance",
    image: "/facilities/Emergency Medicine.png",
    shortDescription: "24/7 trauma care, ACLS ambulances, and high-priority critical response.",
    description: "SAINIK's Emergency Medicine department is staffed with trained trauma specialists and is open 24/7. Equipped with triage systems, critical care bays, and advanced cardiac life support (ACLS) ambulances, we offer immediate intervention.",
    services: [
      "24/7 Triage & Critical Care Emergency Center",
      "Trauma Resuscitation & Stabilization Bays",
      "ACLS Equipped Ambulance Network",
      "Poisoning and Burns Stabilization Support",
      "Disaster & Multi-Casualty Management Response"
    ]
  },
  {
    id: "icu",
    name: "ICU (Intensive Care Unit)",
    icon: "FaHeartbeat",
    image: "https://images.unsplash.com/photo-1516549655169-df83a0774514?auto=format&fit=crop&q=80&w=800",
    shortDescription: "Critical care monitoring, advanced ventilators, and round-the-clock monitoring.",
    description: "The Intensive Care Unit (ICU) provides continuous monitoring and life support for critically ill patients. Staffed by intensivist doctors and specialized nurses, we ensure the highest standards of safety and recovery.",
    services: [
      "Invasive and Non-Invasive Mechanical Ventilation",
      "Multi-Parameter Hemodynamic Monitoring",
      "Bedside Hemodialysis & CRRT Capabilities",
      "Infection-Controlled Isolation ICU Beds",
      "24/7 On-Site Critical Care Consultants"
    ]
  },
  {
    id: "nicu",
    name: "NICU (Neonatal Intensive Care)",
    icon: "FaBabyCarriage",
    image: "/facilities/NICU (Neonatal Intensive Care).png",
    shortDescription: "Highly specialized intensive care for premature infants and newborns.",
    description: "Our Level-III Neonatal Intensive Care Unit (NICU) provides specialized support for premature, low-birth-weight, or critically ill infants. With incubators, neonatal ventilators, and warmers, we nurture fragile newborns.",
    services: [
      "Level-III Advanced Neonatal Intensive Care",
      "Neonatal Mechanical Ventilation & Surfactant Care",
      "Therapeutic Hypothermia for Neonatal Encephalopathy",
      "Phototherapy & Exchange Transfusion Units",
      "Developmental Supportive Care & Kangaroo Care Support"
    ]
  },
  {
    id: "radiology",
    name: "Radiology",
    icon: "FaXRay",
    image: "/facilities/Radiology.png",
    shortDescription: "State-of-the-art MRI, CT Scans, Digital X-Rays, and Ultrasound diagnostics.",
    description: "The Radiology department offers advanced diagnostic imaging. Equipped with high-resolution MRI, multi-slice CT, digital radiography, and high-frequency ultrasound, we ensure precise reporting to guide patient care.",
    services: [
      "High-Resolution 1.5T / 3T MRI Scans",
      "128-Slice Low-Radiation CT Scanning",
      "Digital X-Ray & Orthopantomogram (OPG)",
      "Color Doppler & 3D/4D Ultrasound Imaging",
      "Interventional Radiology & Guided Biopsies"
    ]
  },
  {
    id: "laboratory",
    name: "Laboratory",
    icon: "FaMicroscope",
    image: "/facilities/Laboratory.png",
    shortDescription: "24/7 automated pathology, biochemistry, and microbiology evaluations.",
    description: "Our NABL-accredited laboratory operates 24/7. Using automated analyzers, we perform a wide range of tests in pathology, biochemistry, microbiology, hematology, and clinical pathology, prioritizing speed and accuracy.",
    services: [
      "24/7 Automated Pathology & Clinical Biochemistry",
      "Advanced Microbiology & Culture Services",
      "Hematology & Blood Coagulation Profiling",
      "Immunology, Hormones, & Tumor Marker Assays",
      "NABL-Compliant Quality Audits & Reporting"
    ]
  },
  {
    id: "physiotherapy",
    name: "Physiotherapy",
    icon: "FaWheelchair",
    image: "/facilities/physiotherapy.jpg",
    shortDescription: "Post-surgery rehab, spinal care, and sports physical therapy.",
    description: "The Department of Physiotherapy and Rehabilitation helps patients regain mobility and function. We offer post-operative orthopedic rehab, neurological rehab for stroke patients, spinal therapy, and sports physical therapy.",
    services: [
      "Post-Joint Replacement Rehabilitation Programs",
      "Neurological Physical Therapy (Stroke, Parkinson's)",
      "Ergonomic Advice & Spinal Decompression Care",
      "Sports Injury Physical Therapy & Conditioning",
      "Electrotherapy (IFT, TENS, Ultrasound Therapy)"
    ]
  },
  {
    id: "pharmacy",
    name: "Pharmacy",
    icon: "FaPills",
    image: "/facilities/Pharmacy.png",
    shortDescription: "24/7 hospital pharmacy offering genuine medicines and vaccines.",
    description: "SAINIK Hospital hosts a 24/7 in-house pharmacy, stocking authentic medicines, surgical supplies, healthcare products, and life-saving drugs under temperature-controlled storage.",
    services: [
      "24/7 Dispensing of Authentic Medicines",
      "Temperature-Controlled Storage for Vaccines",
      "Specialty Oncology & Cardiac Medication Storing",
      "In-Patient Surgical Supply Dispatching",
      "Free Pharmacist Consultation for Dosage Advice"
    ]
  }
];

export const doctors = [
  {
    id: "dr-t-amaranath",
    name: "Dr. T. Amaranath",
    qualification: "MBBS, MS (General Surgery)",
    experience: "15+ Years (Clinical) | 25+ Years (Administrative)",
    specialization: "Medical Superintendent & Surgery Consultant",
    department: "general-surgery",
    image: "/doctors/dr-amaranath.png",
    bio: "Dr. T. Amaranath, MBBS, MS (General Surgery) is an experienced General Surgeon with over 25 years of administrative experience and 15+ years of clinical practice. He currently serves as the Medical Superintendent and Surgery Consultant at Sainik Multi-Speciality Hospital. Having worked in government healthcare services, including as DHO and DS, and with over a decade of surgical experience at Bangalore Medical College, Dr. Amaranath has managed a wide range of general surgical conditions. His expertise includes hernia repair, appendectomy, varicose vein surgery, and other routine and advanced general surgical procedures. He is committed to providing safe, ethical, and patient-centered surgical care.",
    treatments: [
      "Hernia Surgery",
      "Appendectomy (Appendix Surgery)",
      "Varicose Vein Surgery",
      "Other General Surgical Procedures"
    ],
    timings: "9:00 AM - 1:00 PM & 4:00 PM - 6:00 PM (Mon - Sat)",
    email: "appointments@sainikhospital.com",
    phone: "6361611986"
  },
  {
    id: "dr-jagadeesh-d-s",
    name: "Dr. Jagadeesh D S",
    qualification: "MBBS, D'ORTHO, MS ORTHO, DNB ORTHO",
    experience: "16+ Years",
    specialization: "Consultant Orthopaedic Surgeon",
    department: "orthopaedics",
    image: "/doctors/dr-jagadeesh.jpg",
    bio: "Dr. Jagadeesh D S is a highly experienced Consultant Orthopaedic Surgeon at SAINIK Multi-Speciality Hospital, Mysuru. He specializes in General Orthopaedics, Complex Trauma, Pelvic & Acetabular Surgeries, Primary & Revision Joint Replacements, Knee & Shoulder Arthroscopy, Sports Injury Management, and Comprehensive Spine Care.",
    timings: "10:00 AM - 12:00 PM & 4:00 PM - 6:00 PM (Mon - Sat)",
    email: "appointments@sainikhospital.com",
    phone: "6361611986"
  },
  {
    id: "dr-prashanth-kumar-m",
    name: "Dr. Prashanth Kumar M",
    qualification: "MBBS, DNB, MNAMS",
    experience: "14+ Years",
    specialization: "Pediatric and General Surgeon",
    department: "general-surgery",
    image: "/doctors/dr-prashanth.jpg",
    bio: "Dr. Prashanth Kumar M is a distinguished Pediatric and General Surgeon specializing in Laparoscopic Surgery, Pediatric Hernia & Hydrocele, Undescended Testis, Birth Defects, Pediatric Urology, Appendicitis, Gall Bladder Stones, Intestinal Surgery, and Accidents/Trauma.",
    timings: "9:00 AM - 1:00 PM & 6:00 PM - 8:00 PM (Mon - Sat)",
    email: "appointments@sainikhospital.com",
    phone: "6361611986"
  },
  {
    id: "dr-sowmya-g",
    name: "Dr. Sowmya G",
    qualification: "MBBS, MD (Internal Medicine)",
    experience: "12+ Years",
    specialization: "Consultant Physician",
    department: "general-medicine",
    image: "/doctors/dr-sowmya.jpg",
    bio: "Dr. Sowmya G is a compassionate Consultant Physician in Internal Medicine at SAINIK Multi-Speciality Hospital, Mysuru. Her areas of expertise include Diabetes, Hypertension, Thyroid Disorders, Fever, Anaemia, Gastroenteritis, GERD, COPD, Allergies, and Preventive Healthcare.",
    timings: "9:00 AM - 1:00 PM (Mon - Sat)",
    email: "appointments@sainikhospital.com",
    phone: "6361611986"
  },
  {
    id: "dr-ashwini",
    name: "Dr. Ashwini",
    qualification: "MBBS, MS (OBG), FMAS, DMAS, FELLOWSHIP IN ART",
    experience: "10+ Years",
    specialization: "Consultant Obstetrician & Gynecologist",
    department: "obstetrics-gynaecology",
    image: "/doctors/dr-ashwini.jpg",
    bio: "Dr. Ashwini is a leading Consultant Obstetrician, Gynecologist, and Infertility Specialist. She specializes in Infertility Evaluation, IUI, IVF, Painless Labor, Cesarean Delivery, Antenatal & Postpartum Care, Laparoscopic Surgeries, PCOS, Menstrual Disorders, and Cancer Screening.",
    timings: "4:00 PM - 8:00 PM (Mon - Sat)",
    email: "appointments@sainikhospital.com",
    phone: "6361611986"
  },
  {
    id: "dr-chaitra-ravikumar",
    name: "Dr. Chaitra Ravikumar",
    qualification: "MBBS, MS (OBG)",
    experience: "11+ Years",
    specialization: "Consultant Obstetrician & Gynecologist",
    department: "obstetrics-gynaecology",
    image: "/doctors/dr-chaitra.jpg",
    bio: "Dr. Chaitra Ravikumar is an experienced Consultant Obstetrician & Gynecologist at SAINIK Multi-Speciality Hospital, Mysuru. She provides comprehensive care for Preconception Counseling, Antenatal Care, High-Risk Pregnancy, Gestational Diabetes, PCOS, Hysteroscopy, Laparoscopy, and Women's Wellness.",
    timings: "10:00 AM - 1:00 PM & 5:00 PM - 8:00 PM (Mon - Sat)",
    email: "appointments@sainikhospital.com",
    phone: "6361611986"
  },
  {
    id: "dr-shiny-vijay",
    name: "Dr. Shiny Vijay (PT)",
    qualification: "BPT | MSc Sports Management (United Kingdom) | MIAP",
    experience: "10+ Years",
    specialization: "Consultant Physiotherapist",
    department: "physiotherapy",
    image: "/doctors/dr-shiny.png",
    bio: "Dr. Shiny Vijay (PT) is an internationally experienced Consultant Physiotherapist at SAINIK Multi-Speciality Hospital, Mysuru. Holding a Master's degree from the United Kingdom (MSc Sports Management) and MIAP certification, she brings advanced international clinical expertise in Orthopaedic, Neurological, ICU & Respiratory, Sports, Women's Health, Paediatric, and Post-Surgical Rehabilitation.",
    treatments: [
      "Orthopaedic Rehabilitation (Back, Neck & Knee Pain, Joint & Tendon Care)",
      "Post-Surgical Rehabilitation (Joint Replacement, ACL/PCL Reconstruction, Spine)",
      "Neurological Rehabilitation (Stroke, Parkinson's, Bell's Palsy, Gait Training)",
      "ICU & Respiratory Physiotherapy (Chest Physio, Breathing Exercises, Early Mobilisation)",
      "Women's Health Physiotherapy (Pelvic Girdle, Post-natal Rehab)",
      "Paediatric Physiotherapy & Development Delay Care",
      "Sports & Musculoskeletal Rehabilitation (Sports Injuries, Tendon & Muscle Sprains)"
    ],
    timings: "9:00 AM - 1:00 PM & 4:00 PM - 7:00 PM (Mon - Sat)",
    email: "appointments@sainikhospital.com",
    phone: "6361611986 / 7026808107"
  },
  {
    id: "dr-shivaranjini",
    name: "Dr. Shivaranjini",
    qualification: "MBBS, DGO, DNB, FMAS, DMAS, DIPLOMATE IN COSMETIC & AESTHETIC GYNAECOLOGY",
    experience: "12+ Years",
    specialization: "Consultant Obstetrician & Gynaecologist",
    department: "obstetrics-gynaecology",
    image: "/doctors/dr-shivaranjini.png",
    bio: "Dr. Shivaranjini is a highly accomplished Consultant Obstetrician, Gynecologist, and Cosmetic Gynaecology Specialist at SAINIK Multi-Speciality Hospital, Mysuru. Armed with advanced certifications in Minimal Access Surgery (FMAS, DMAS) and Cosmetic Gynaecology, she delivers compassionate care across high-risk pregnancy, laparoscopic procedures, infertility management, and aesthetic gynaecological treatments.",
    treatments: [
      "High-Risk Pregnancy, Antenatal Care & Prenatal Counseling",
      "Painless Delivery, Normal & Instrumental Delivery, Caesarean Delivery",
      "Laparoscopic & Hysteroscopic Surgeries, Hysterectomy",
      "Cosmetic & Aesthetic Gynaecology (G-Shot, O-Shots, Vaginal Rejuvenation Procedures)",
      "PCOS, Menstrual Irregularities, Perimenopausal & Postmenopausal Care",
      "Infertility Workup, Preventive Care & Cancer Screening"
    ],
    timings: "10:30 AM - 12:30 PM (Mon - Sat)",
    email: "appointments@sainikhospital.com",
    phone: "6361611986 / 7026808107"
  },
  {
    id: "dr-harini-v",
    name: "Dr. Harini V.",
    qualification: "MBBS, MD (Pediatrics), DNB (Pediatrics)",
    experience: "10+ Years",
    specialization: "Consultant Pediatrician",
    department: "paediatrics",
    image: "/doctors/dr-harini.jpg",
    bio: "Dr. Harini V. is a dedicated Consultant Pediatrician at SAINIK Multi-Speciality Hospital, offering expert care in newborn and infant health, growth monitoring, and pediatric emergencies.",
    treatments: [
      "Newborn & Infant Care",
      "Growth & Development Monitoring",
      "Vaccination & Immunization Guidance",
      "Fever, Cough & Common Infections",
      "Respiratory & Allergy Problems",
      "Nutrition & Poor Weight Gain Assessment",
      "Developmental & Behavioral Guidance",
      "Pediatric Emergency Care"
    ],
    timings: "5:00 PM - 8:00 PM (Mon - Sat)",
    email: "appointments@sainikhospital.com",
    phone: "6361611986"
  }
];

export const testimonials = [
  {
    id: 1,
    name: "Srikantha",
    relation: "Google Review",
    rating: 5,
    comment: "I had a wonderful experience at sainik. The doctors and nursing staff were professional and compassionate throughout treatment. The facilities were well-maintained and the medical equipment felt very advanced. Highly recommend this hospital..",
    avatar: "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?auto=format&fit=crop&q=80&w=150"
  },
  {
    id: 2,
    name: "yashu yashu",
    relation: "Local Guide",
    rating: 5,
    comment: "Excellent experience at Sainik Multispeciality Hospital. The facility is clean and well-maintained. The doctors and nursing staff are highly professional, compassionate, and attentive. They explained the treatment process clearly, which gave us great peace of mind. Highly recommend this hospital in Mysuru for reliable round-the-clock medical care.",
    avatar: "https://images.unsplash.com/photo-1494790108377-be9c29b29330?auto=format&fit=crop&q=80&w=150"
  },
  {
    id: 3,
    name: "Vijaya Viji",
    relation: "Google Review",
    rating: 5,
    comment: "It is a great pleasure that Sainik Hospital is conducting a free camp because it has helped so many people. It is very good.",
    avatar: "https://images.unsplash.com/photo-1500648767791-00dcc994a43e?auto=format&fit=crop&q=80&w=150"
  },
  {
    id: 4,
    name: "Madhura Shinde",
    relation: "Google Review",
    rating: 5,
    comment: "Best doctors in the hospital, best multi-speciality hospital in mysore, recommended to everyone available 24/7",
    avatar: "https://images.unsplash.com/photo-1544005313-94ddf0286df2?auto=format&fit=crop&q=80&w=150"
  }
];

export const galleryItems = [
  {
    id: 1,
    category: "hospital",
    title: "SAINIK Pharma Storefront",
    image: "/gallery/sainik-pharma.jpg",
    description: "24/7 fully stocked SAINIK Pharma unit providing essential medicines, surgical supplies, and healthcare products."
  },
  {
    id: 2,
    category: "infrastructure",
    title: "SAINIK Reception & Patient Waiting Lounge",
    image: "/gallery/sainik-reception.jpg",
    description: "Spacious, modern reception counter and comfortable patient waiting area at SAINIK Multi-Speciality Hospital."
  },
  {
    id: 3,
    category: "infrastructure",
    title: "Modular Operation Theatre (OT)",
    image: "/gallery/ChatGPT Image Jul 23, 2026, 04_04_56 PM.png",
    description: "State-of-the-art modular surgical suite equipped with advanced surgical lighting, monitors, and anesthesia workstation."
  },
  {
    id: 4,
    category: "infrastructure",
    title: "Hospital Waiting Lounge & Pharmacy Counter",
    image: "/gallery/ChatGPT Image Jul 23, 2026, 04_06_02 PM.png",
    description: "Clean, comfortable in-patient and visitor lounge area near the in-house hospital pharmacy counter."
  },
  {
    id: 5,
    category: "equipment",
    title: "24/7 Emergency Ambulance Fleet",
    image: "/gallery/ChatGPT Image Jul 23, 2026, 04_08_46 PM.png",
    description: "Advanced Cardiac Life Support (ACLS) emergency response ambulances available round-the-clock."
  },
  {
    id: 6,
    category: "equipment",
    title: "Advanced Diagnostic Microscope",
    image: "/gallery/ChatGPT Image Jul 23, 2026, 04_10_08 PM.png",
    description: "High-precision optical microscope used in our NABL compliant pathology laboratory for cellular analysis."
  },
  {
    id: 7,
    category: "infrastructure",
    title: "Hospital Elevator Lobby & Block-A",
    image: "/gallery/ChatGPT Image Jul 23, 2026, 04_11_18 PM.png",
    description: "Modern patient and visitor elevators providing seamless accessibility across all hospital floors."
  },
  {
    id: 8,
    category: "equipment",
    title: "Automated Diagnostic Laboratory",
    image: "/gallery/ChatGPT Image Jul 23, 2026, 04_13_00 PM.png",
    description: "Fully automated clinical biochemistry analyzers and pathology processing station."
  },
  {
    id: 9,
    category: "infrastructure",
    title: "In-Patient Recovery Ward",
    image: "/gallery/ChatGPT Image Jul 23, 2026, 04_15_20 PM.png",
    description: "Hygiene-maintained, multi-bed in-patient recovery ward with central medical oxygen and nursing care."
  },
  {
    id: 10,
    category: "infrastructure",
    title: "Intensive Care Unit (ICU)",
    image: "/gallery/ChatGPT Image Jul 23, 2026, 04_22_42 PM.png",
    description: "Advanced ICU setup with multi-parameter vitals monitoring, mechanical ventilators, and round-the-clock intensivist support."
  },
  {
    id: 11,
    category: "equipment",
    title: "Laparoscopic & Endoscopy Video Tower",
    image: "/gallery/ChatGPT Image Jul 23, 2026, 04_53_05 PM.png",
    description: "High-definition surgical video tower for minimally invasive laparoscopic and endoscopic procedures."
  },
  {
    id: 12,
    category: "camp",
    title: "Health Camp Pharmacy Counter",
    image: "/gallery/camp-pharmacy.jpg",
    description: "Patients visiting the pharmacy counter during our free health awareness camp."
  },
  {
    id: 13,
    category: "camp",
    title: "Health Camp Blood Check",
    image: "/gallery/camp-blood-check.jpg",
    description: "Our dedicated staff performing routine blood checks at the health camp."
  },
  {
    id: 14,
    category: "camp",
    title: "Health Camp Consultation",
    image: "/gallery/camp-consultation.jpg",
    description: "Medical staff consulting with patients during the community health camp."
  },
  {
    id: 15,
    category: "camp",
    title: "Health Camp Physician Checkup",
    image: "/gallery/camp-physician.jpg",
    description: "Doctors performing thorough checkups and auscultations at the health camp."
  },
  {
    id: 16,
    category: "camp",
    title: "Health Camp Doctor Consultation",
    image: "/gallery/camp-doctor-consultation.jpg",
    description: "Personalized medical consultation provided during our health camp."
  },
  {
    id: 17,
    category: "camp",
    title: "Health Camp Waiting Area",
    image: "/gallery/camp-waiting-area.jpg",
    description: "Patients resting comfortably in the waiting lounge during the camp."
  },
  {
    id: 18,
    category: "camp",
    title: "Health Camp Event",
    image: "/gallery/IMG_8675.jpg",
    description: "Glimpses from our recent successful health camp."
  },
  {
    id: 19,
    category: "camp",
    title: "Health Camp Event",
    image: "/gallery/IMG_8688.jpg",
    description: "Glimpses from our recent successful health camp."
  },
  {
    id: 20,
    category: "camp",
    title: "Health Camp Event",
    image: "/gallery/IMG_8689.jpg",
    description: "Glimpses from our recent successful health camp."
  },
  {
    id: 21,
    category: "camp",
    title: "Health Camp Event",
    image: "/gallery/IMG_8695.jpg",
    description: "Glimpses from our recent successful health camp."
  }
];


export const healthPackages = [
  {
    id: "sainik-premium-cardiac",
    name: "SAINIK Premium Cardiac Health Package",
    price: "₹3,999",
    description: "Extensive cardiovascular evaluation designed for early detection of heart disease.",
    tests: [
      "Consultation with Senior Cardiologist",
      "2D Echocardiography (ECHO)",
      "Cardiac Treadmill Test (TMT)",
      "Electrocardiogram (ECG) & Chest X-Ray",
      "Lipid Profile (Cholesterol, HDL, LDL, Triglycerides)",
      "HbA1c & Fasting Blood Sugar",
      "Kidney & Liver Function Panel"
    ]
  },
  {
    id: "sainik-executive-health",
    name: "Executive Whole Body Health Package",
    price: "₹5,999",
    description: "Our most complete diagnostic checkup tailored for professionals and seniors.",
    tests: [
      "Consultations with Internist, Cardiologist & Ophthalmologist",
      "Ultrasound Scan of Abdomen & Pelvis",
      "Pulmonary Function Test (PFT)",
      "Complete Blood Count (CBC) & ESR",
      "Comprehensive Thyroid Profile (T3, T4, TSH)",
      "Urine Analysis & Serum Creatinine",
      "Bone Mineral Density & Vitamin D3/B12"
    ]
  },
  {
    id: "sainik-women-wellness",
    name: "Women Advanced Wellness Checkup",
    price: "₹3,999",
    description: "Tailored health profiling for women, focused on hormonal, bone, and gynaec wellness.",
    tests: [
      "Consultation with Senior Gynaecologist",
      "Pelvic Ultrasound (USG)",
      "Mammography or Breast Ultrasound",
      "Pap Smear Screening",
      "Bone Mineral Density (BMD)",
      "Thyroid Screening (TSH)",
      "Anaemia Profile (Iron, Ferritin, Hemoglobin)"
    ]
  }
];

export const faqs = [
  {
    id: 1,
    question: "How do I book a doctor's appointment at SAINIK Hospital?",
    answer: "You can book an appointment by clicking the 'Book Appointment' button on the banner, filling out the quick scheduling form, or calling our 24/7 central desk directly at +91 80 4455 6677. For first-time visitors, please arrive 15 minutes early to register."
  },
  {
    id: 2,
    question: "Does SAINIK Hospital support cashless insurance policies?",
    answer: "Yes, SAINIK Multi-Speciality Hospital is empaneled with all major third-party administrators (TPAs) and leading corporate insurance providers. Please present your insurance e-card at our Admission Desk during admission to initiate the pre-authorization process."
  },
  {
    id: 3,
    question: "What are the visiting hours for the Intensive Care Units (ICUs)?",
    answer: "To ensure a clean environment and adequate rest for patients, visiting hours in ICU/NICU are restricted to: Morning 11:00 AM - 12:00 PM and Evening 05:00 PM - 06:00 PM. Only one immediate family member is permitted at a time with a valid ICU visitor pass."
  },
  {
    id: 4,
    question: "Are emergency and ambulance services active 24/7?",
    answer: "Absolutely. Our fully-equipped Advanced Cardiac Life Support (ACLS) ambulances are active round-the-clock. You can request emergency pickup by dialing our dedicated hotline: 6361611986. An emergency coordinator will guide you instantly."
  }
];

export const hospitalFacilities = [
  {
    id: "fac-ambulance",
    title: "24/7 ACLS Ambulance Service",
    icon: "FaAmbulance",
    badge: "Emergency 24x7",
    category: "Emergency & Critical Care",
    image: "/facilities/Emergency Medicine.png",
    description: "Fully-equipped Advanced Cardiac Life Support (ACLS) ambulances with ventilators and trained paramedics active round-the-clock."
  },
  {
    id: "fac-pharmacy",
    title: "24x7 In-House Pharmacy",
    icon: "FaPills",
    badge: "Available 24x7",
    category: "Hospital Services",
    image: "/facilities/Pharmacy.png",
    description: "Stocked with genuine prescription medicines, emergency cardiac life-saving drugs, surgical supplies, and temperature-controlled vaccines."
  },
  {
    id: "fac-lab",
    title: "24x7 Automated Lab Services",
    icon: "FaMicroscope",
    badge: "Diagnostics 24x7",
    category: "Laboratory & Diagnostics",
    image: "/facilities/Laboratory.png",
    description: "High-precision NABL compliant automated pathology, clinical biochemistry, microbiology, hematology, and hormone assays."
  },
  {
    id: "fac-icu",
    title: "Intensive Care Unit (ICU)",
    icon: "FaHeartbeat",
    badge: "Critical Care",
    category: "Emergency & Critical Care",
    image: "https://images.unsplash.com/photo-1516549655169-df83a0774514?auto=format&fit=crop&q=80&w=800",
    description: "Advanced multi-parameter hemodynamic monitoring, mechanical ventilation, bedside hemodialysis, and dedicated 24/7 intensivist supervision."
  },
  {
    id: "fac-nicu",
    title: "Neonatal Intensive Care Unit (NICU)",
    icon: "FaBabyCarriage",
    badge: "Pediatric Critical Care",
    category: "Emergency & Critical Care",
    image: "/facilities/NICU (Neonatal Intensive Care).png",
    description: "Level-III NICU care for premature newborns and low-birth-weight infants equipped with modern warmers and neonatal ventilators."
  },
  {
    id: "fac-dialysis",
    title: "Dialysis Unit",
    icon: "FaProcedures",
    badge: "Kidney Care",
    category: "Specialized Clinical Unit",
    image: "https://images.unsplash.com/photo-1505751172876-fa1923c5c528?auto=format&fit=crop&q=80&w=800",
    description: "State-of-the-art hemodialysis and peritoneal dialysis station operating under strict sterile standards for kidney failure management."
  },
  {
    id: "fac-radiology",
    title: "Radiology & Diagnostic Imaging",
    icon: "FaXRay",
    badge: "Advanced Imaging",
    category: "Laboratory & Diagnostics",
    image: "/facilities/Radiology.png",
    description: "High-resolution MRI scans, 128-slice CT scans, Digital X-Ray (OPG), 3D/4D Color Doppler Ultrasound, and image-guided biopsies."
  },
  {
    id: "fac-physiotherapy",
    title: "Physiotherapy & Rehabilitation",
    icon: "FaWheelchair",
    badge: "Rehabilitation",
    category: "Therapy & Wellness",
    image: "https://images.unsplash.com/photo-1576091160550-2173dba999ef?auto=format&fit=crop&q=80&w=800",
    description: "Post-surgery joint replacement rehabilitation, stroke recovery therapy, spinal care, ergonomic advice, and sports conditioning."
  },
  {
    id: "fac-healthcheck",
    title: "Health Checkup & Corporate Packages",
    icon: "FaStethoscope",
    badge: "Preventive Care",
    category: "Therapy & Wellness",
    image: "https://images.unsplash.com/photo-1576091160399-112ba8d25d1d?auto=format&fit=crop&q=80&w=800",
    description: "Tailored executive health screening, cardiac evaluations, women wellness checkups, and corporate pre-employment health audits."
  },
  {
    id: "fac-facio-maxillary",
    title: "Facio Maxillary Surgery Unit",
    icon: "FaUserMd",
    badge: "Surgical Suite",
    category: "Specialized Surgery",
    image: "https://images.unsplash.com/photo-1551076805-e1869033e561?auto=format&fit=crop&q=80&w=800",
    description: "Expert facial trauma reconstruction, jaw correction surgeries, facial bone fracture repair, and maxillofacial surgery."
  }
];

